import { FacilityBrand } from '@/gqlConstants';
import { NearbyFacility, NearbyFacilitiesList } from '@/graphql/__generated/sdk';
import { getGraphHeaders } from '@/utils/getGraphHeaders';
import { TAGBrand } from '@/types';

import { brandThemeToFacilityBrand } from './brandThemeToFacilityBrand';

export interface INearbyFacilities {
	appName: string;
	appVersion: string;
	enterpriseGraphqlUrl: string;
	brand: TAGBrand;
	coords: {
		latitude: number;
		longitude: number;
	};
	withinRadius?: number;
}

/** get nearby facilities from enterprise graphql
 * @param appName - name of the application
 * @param appVersion - version of the application
 * @param enterpriseGraphqlUrl - url of the enterprise graphql
 * @param brand - brand of the facility
 * @param coords - coordinates of the facility
 * @param withinRadius - radius within which to search for nearby facilities default is 200
 * @returns nearby facilities
 */
export async function getNearbyFacilities({
	appName,
	appVersion,
	enterpriseGraphqlUrl,
	brand,
	coords,
	withinRadius = 200,
}: INearbyFacilities): Promise<NearbyFacility[]> {
	const { latitude, longitude } = coords;
	if (!latitude || !longitude) {
		return [];
	}
	const facilityBrand = brandThemeToFacilityBrand(brand);
	const { getGraphQLClient } = await import(/* webpackChunkName:"getGraphQLClient" */ '../graphql/getGraphQLClient');
	const facilitiesResponse = await getGraphQLClient(enterpriseGraphqlUrl).nearbyFacilities(
		{
			filter: {
				latitude,
				longitude,
				withinRadius,
				brand: facilityBrand as FacilityBrand,
			},
		},
		getGraphHeaders(appName, appVersion)
	);
	const nearbyFacilities = facilitiesResponse.nearbyFacilities as NearbyFacilitiesList;

	return nearbyFacilities.items;
}
